import styled from 'styled-components';
import { RatingStarsMixin } from '../../mixins/components/RatingStarsMixin';
import { doNotForwardTransientProp } from '../../util/doNotForwardTransientProp';
export var StyledRatingStars = /*#__PURE__*/styled('span').withConfig({
  shouldForwardProp: doNotForwardTransientProp(['value'])
}).withConfig({
  displayName: "StyledRatingStars",
  componentId: "c11n-8-111-1__sc-ehkjiy-0"
})(["", ""], RatingStarsMixin);